export const CONTEXT_KEY = {
  PROJECT_CONTEXT: 'project',
  SELECTED_PROJECT_CONTEXT: 'selected-project',
  HOME_GEO_CONTEXT: 'home-geo',
  SELECTED_GEO_CONTEXT: 'selected-geo',
};

export const isSignalRForSocketConnectionEnabled =
  window?.TIEOUT?.ENV?.FEATURE.ENABLE_SIGNALR_SOCKET_CONNECTION;
